import { blob } from "stream/consumers";
import action from "../helpers/rest-client";

export class ErrorFile extends Error {}

interface GetFile {
  id: number;
  fileId: number;
}

class File {
  public getCourseFile({ id, fileId }: GetFile) {
    return action
      .Get({
        url: `file/labCourse/${id}/${fileId}`,
        config: { responseType: "blob" },
      })
      .then((response) => {
        return URL.createObjectURL(response);
      })
      .catch((error) => {
        return { error };
      });
  }

  public getUnitFile({ id, fileId }: GetFile) {
    return action
      .Get({
        url: `file/labUnit/${id}/${fileId}`,
      })
      .then((response) => {
        return { response: response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public getComponentFile({ id, fileId }: GetFile) {
    return action
      .Get({
        url: `file/labComponent/${id}/${fileId}`,
        config: { responseType: "blob" },
      })
      .then((response) => {
        return { response: URL.createObjectURL(response), error: null };
      })
      .catch((error) => {
        return { response: null, error };
      });
  }
}

const file = new File();
export default file;
